import { defineAction } from '~/prix'
import inventoryUpdateAction from './inventoryUpdate.action.json' with { type: 'json' }
import { inventoryObject } from '../inventoryObject'
import { z } from 'zod'

const inventoryUpdateDefinition = defineAction({
  ...inventoryUpdateAction,

  input: inventoryObject,
  output: z.object({}),
})

export default inventoryUpdateDefinition
